<template>
    <v-content class="main-page-wrap text-justify">
        <h2 class="headline text-xs-center mb-4 mt-4">{{title}}</h2>

        <form @submit.prevent="onSubmit" class="mb-4">
            <v-layout wrap>
                <v-flex class="mt-2" xs12 v-for="(cat, i) in items" :key="i">
                    <div class="mb-3">{{cat.text}}</div>
                    <question-input
                            v-if="cat.type === 'input'"
                            :hunt="cat.hint"
                            :label="cat.label"
                            :error="cat.error"
                            v-model="cat.value"
                    />
                    <question-radio
                            :has-index="cat.hasIndex"
                            :index-offset="0"
                            v-if="cat.type === 'radio'"
                            :items="cat.items"
                            :label="cat.label"
                            v-model="cat.value"
                            :error="cat.error"
                    />
                </v-flex>

                <v-flex xs12>
                    <v-spacer class="mt-5"></v-spacer>
                    <v-layout align-center>
                        <v-flex>
                            <v-checkbox
                                    class="checkbox"
                                    requiredcolor="info"
                                    v-model="personal"
                                    :error="personalErrors"
                                    hide-details
                            />
                        </v-flex>
                        <v-flex xs12>
                            <div :class="{'error--text': personalErrors}">
                                Даю согласие на обработку
                                <a href="/agreement.pdf" target="_blank">персональных данных</a>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

            <div class="mt-5 text-xs-center">
                <v-btn :loading="pending" type="submit" color="success">Продолжить</v-btn>
            </div>
        </form>
    </v-content>
</template>

<script>
    import { mapState } from 'vuex'
    import QuestionInput from '@/components/question/input'
    import QuestionRadio from '@/components/question/radio'

    export default {
        components: {
            QuestionInput,
            QuestionRadio
        },
        data () {
            return {
                pending: false,
                personal: false,
                personalErrors: false,
                items: [
                    {
                        type: 'input',
                        required: true,
                        text: 'Как к Вам обращаться',
                        label: '(Ф.И.О.)',
                        key: 'fio',
                        error: false,
                        value: ''
                    },
                    {
                        type: 'input',
                        text: 'Для получения результатов укажите электронную почту',
                        label: 'e-mail',
                        key: 'email',
                        error: false,
                        value: ''
                    },
                    {
                        type: 'input',
                        text: 'Для связи с Вами укажите телефонный номер',
                        label: '+7(xxx)-xxx-xx-xx',
                        key: 'phone',
                        error: false,
                        value: ''
                    },
                    {
                        type: 'input',
                        required: true,
                        text: 'Укажите, пожалуйста, Ваш возраст',
                        label: 'количество полных лет',
                        error: false,
                        key: 'age',
                        value: ''
                    },
                    {
                        type: 'radio',
                        required: true,
                        text: 'Ваш пол',
                        items: [{answer: 'Мужской'}, {answer: 'Женский'}],
                        error: false,
                        key: 'gender',
                        value: ''
                    }
                ]
            }
        },
        computed: {
            ...mapState('auth', ['role']),

            title () {
                if (this.role === 'employer') {
                    return 'Общая информация'
                } else {
                    return 'Информация об участнике исследования'
                }
            },
            sendData () {
                return this.items.reduce((result, item) => {
                    result[item.key] = item.value
                    return result
                }, {})
            }
        },
        methods: {
            onSubmit () {
                let error = this.items.reduce((error, item) => {
                    item.error = item.required ? !item.value : false
                    return item.error || error
                }, false)

                this.personalErrors = !this.personal

                if (error || this.personalErrors || this.pending) return
                this.pending = true

                this.$store.dispatch('profile/update', this.sendData)
                    .then(() => {
                        this.pending = false
                        this.$store.dispatch('testing/start', 'start')
                    })
                    .catch(() => {
                        this.pending = false
                    })
            }
        },
        created () {
            if (this.role !== 'employer') {
                this.items.push({
                    key: 'education',
                    type: 'radio',
                    text: 'Укажите самый высокий уровень завершенного образования, который Вы сейчас имеете',
                    items: [
                        {answer: 'Нет образования'},
                        {answer: 'Начальное школьное'},
                        {answer: 'Средняя школа, без аттестата'},
                        {answer: 'Средняя школа, с аттестатом'},
                        {answer: 'Начальное профессиональное образование (профессионально-техническое училище)'},
                        {answer: 'Среднее профессиональное образование (техникум, колледж, медицинское училище)'},
                        {answer: 'Высшее образование (бакалавриат, специалитет в университете, академии, институте)'},
                        {answer: 'Магистратура'},
                        {answer: 'Аспирантура, ординатура'},
                        {answer: 'Ученая степень кандидата / доктора наук'},
                        {answer: 'Другое'}
                    ],
                    hasIndex: true,
                    error: false,
                    required: true,
                    value: ''
                })
            }

            if (this.role === 'employer') {
                this.items.push({
                    key: 'company',
                    type: 'input',
                    text: 'Введите название вашей компании',
                    error: false,
                    value: ''
                })
            }

            if (this.role === 'worker') {
                this.items.push({
                    key: 'company',
                    type: 'input',
                    text: 'Введите название компании в которой вы работаете',
                    error: false,
                    value: ''
                })
            }
        }
    }
</script>

<style scoped>
    .checkbox {
        margin-right: 10px;
    }
</style>

